export const DEFAULT_SORT_ORDER_STATE = { field: "publishedAt", direction: "desc" };
//
// Action types
//

export const UPDATE_SORT_ORDER = "UPDATE_SORT_ORDER";
export const REGENERATE_SORT_ORDER_SEED = "REGENERATE_SORT_ORDER_SEED";

//
// Action creators
//

export function updateSortOrder(resourcesListKey, field, direction, requiresSeed) {
  return {
    type: UPDATE_SORT_ORDER,
    resourcesListKey,
    field,
    direction,
    requiresSeed
  };
}

export function regenerateSortOrderSeed(resourcesListKey) {
  return {
    type: REGENERATE_SORT_ORDER_SEED,
    resourcesListKey
  };
}

function generateSeed() {
  return Math.random().toString();
}

function updateSortOrderHandler(state, field, direction, requiresSeed) {
  const newState = { field, direction };

  // If the sort order requires a seed to be provided, which is the case to have a
  // consistent pagination order with random ordering, we fetch it from the store or
  // generate it, and add it to the sortOrder state.
  if (requiresSeed) {
    const seed = state.seed || generateSeed();
    newState.seed = seed;
  }

  return newState;
}

function regenerateSortOrderSeedHandler(state) {
  const seed = generateSeed();

  return { ...state, seed };
}

//
// Reducer and handlers
//

export function reduceSortOrder(state, action) {
  switch (action && action.type) {
    case UPDATE_SORT_ORDER:
      return updateSortOrderHandler(
        state,
        action.field,
        action.direction,
        action.requiresSeed
      );

    case REGENERATE_SORT_ORDER_SEED:
      return regenerateSortOrderSeedHandler(state);

    default:
      return state || DEFAULT_SORT_ORDER_STATE;
  }
}
